export const inventory = {
  description: "Stock levels, movements, and job material issue.",
  column: {
    onHand: "On hand",
    reorder: "Reorder",
  },
  lowStock: "Low stock",
  inStock: "In stock",
  addLocation: "Add location",
  stockLevels: "Stock levels",
  emptyTitle: "No materials",
  emptyDescription: "Add materials in the catalog to begin tracking stock.",
  selectMaterial: "Select a material to see locations, movements, and issue actions.",
  location: "Location",
  direction: "Direction",
  stockIn: "Stock in",
  stockOut: "Stock out",
  reasonHint: "Required (minimum 3 characters).",
  recordAdjustment: "Record adjustment",
  adjustmentRecorded: "Adjustment recorded",
  job: "Job",
  issuing: "Issuing…",
  issueToJob: "Issue to job",
  materialIssued: "Material issued",
  addLocationTitle: "Add a stock location",
  saveLocation: "Save location",
  locationAdded: "Location added",
  locationKind: {
    store: "Store",
    floor: "Shop floor",
    quarantine: "Quarantine",
    other: "Other",
  },
  totalOnHand: "Total on hand",
  adjust: "Adjust",
  issue: "Issue",
  movementHistory: "Movement history",
  noMovements: "No movements yet.",
  reverseTitle: "Reverse this movement?",
  reverseDescription:
    "A reversing movement is recorded against the original for a full audit trail.",
  reverseMovement: "Reverse movement",
  movementReversed: "Movement reversed",
  reverse: "Reverse",
  reversed: "Reversed",
  kind: {
    opening: "Opening",
    receipt: "Receipt",
    issue: "Job issue",
    return: "Job return",
    adjustment_in: "Adjust in",
    adjustment_out: "Adjust out",
  },
};
